import React, { Component } from 'react'
import { NavLink, withRouter } from 'react-router-dom'
import classnames from 'classnames'
import * as RoleType from '../../constants/user/RoleType';
import If from "../common/control/If";
import {connect} from "react-redux";

function MenuItem({role, item}) {
  if(!RoleType.canAccess(role, item.requireRole)) {
    return null
  }

  if (item.external) {
    return <li><a href={item.to} target="_blank" className="link_menu">{item.name}<span className="ico_blog ico_blank"/></a></li>
  } else {
    return <li><NavLink activeClassName="on" className="link_menu" to={item.to}>{item.name}</NavLink></li>
  }
}

@withRouter
@connect(state => ({
  revenue: state.revenue,
}))
class MenuGroup extends Component {

  isActive() {
    const { menu, location } = this.props
    return menu.filter(item => location.pathname.startsWith(item.to)).length > 0
  }

  render() {
    const { ico, name, menu, currentRole, activePlugins, revenue, to } = this.props;
    const canAccessOneMoreMenu = (menu.filter(item => RoleType.canAccess(currentRole, item.requireRole)).length > 0);

    if (!canAccessOneMoreMenu) {
      return null;
    }

    let excludeMenuName = [];
    if(activePlugins) {
      if(activePlugins.indexOf('KeywordUI') === -1){
        excludeMenuName.push('키워드 관리')
      }
    }
    if (!revenue.revenueVendors.includes('adfit')) {
      excludeMenuName.push('애드핏 관리');
    }
    if (!revenue.revenueVendors.includes('adsense')) {
      excludeMenuName.push('애드센스 관리');
    }

    const renderMenu = menu.filter(item => !excludeMenuName.find(excludeName => excludeName === item.name));

    return (
        <div className="wrap_menu">
          {to &&
          <NavLink className="tit_menu tit_line" exact activeClassName="on" to={to} style={{ textDecoration:'none' }}>
            <span className="link_menu"><span className={`ico_blog ${ico}`}/>{name}</span>
          </NavLink>
          }
          {
            !to &&
            <strong className={classnames("tit_menu", {"on": this.isActive()})}><span className={classnames("ico_blog", ico)} />{name}</strong>
          }
          <If condition={renderMenu.length > 0}><ul className="list_menu">
            {renderMenu.map((item, index) =>
                <MenuItem key={index} role={currentRole} item={item} />
            )}
          </ul></If>
        </div>
    )
  }
}

export default MenuGroup;
